import React from 'react';
import { Switch, Route } from 'react-router-dom';

import GeoLocation from '../pages/geolocation';
import MainPage from '../pages/mainpage';
import EnteringPage from '../pages/enteringpage';
import DetailPage from '../pages/detailpage';

import RegisterClient from '../pages/Auth/client/Register';
import SuccessMsg from '../components/SuccessMsg';
import DispatchMsg from '../components/DispatchMsg';
import AppDownload from '../components/AppDownload';
import RegisterForm from '../components/RegisterForm';

const Main = () => (
    <Switch>
        <Route exact path='/' component={RegisterClient} />
        <Route exact path='/thankyou/:email' component={SuccessMsg} />
        <Route exact path="/:bId/b" component={MainPage} />
        <Route exact path="/:vipType/:bId/b" component={MainPage} />
        <Route exact path="/register" component={RegisterForm} />
        <Route exact path="/:bId/e" component={EnteringPage} />
        <Route exact path="/:vipType/:bId/e" component={EnteringPage} />
        <Route exact path="/:bId/d" component={DetailPage} />
        <Route exact path="/:vipType/:bId/d" component={DetailPage} />
        <Route exact path="/geo" component={GeoLocation} />
        <Route exact path='/dispatch/:bId/:sId' component={DispatchMsg} />
        <Route exact path='/dl' component={AppDownload} />
    </Switch>
)

export default Main;